import { selectAssetById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"
import { appStore } from "src/store"
import { AssetDetailsView } from "src/views/AssetDetailsView/AssetDetailsView"
import { assetDetailsViewStaticData } from "src/views/AssetDetailsView/constants"
import { NotFound } from "src/views/AssetDetailsView/NotFound"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/$projectId/_projectMap/assets/$assetId")({
	component: AssetDetailsView,
	notFoundComponent: NotFound,
	staticData: assetDetailsViewStaticData,
	remountDeps: ({ params }) => [params.organizationId, params.projectId, params.assetId],
	loader: ({ params }) => {
		const asset = selectAssetById(params.assetId)(appStore.getState())
		if (!asset) throw notFound()
	},
})
